import { UniformsLib, UniformsUtils, Color } from "three";
import { GLOBAL_UNIFORMS } from "./GlobalUniforms";
//  glslify is used for including GLSL shader code
const glslify = require("glslify");
const VERTEX_SHADER = require("./Avatar.vert");
const FRAGMENT_SHADER = require("./Avatar.frag");
export const AVATAR_VERTEX_SHADER = VERTEX_SHADER && glslify(VERTEX_SHADER);
export const AVATAR_FRAGMENT_SHADER = FRAGMENT_SHADER && glslify(FRAGMENT_SHADER);
export const AVATAR_SHADER = {
    uniforms: UniformsUtils.merge([
        /* we need at least some of these to use threes fragments and not get undefined errors */
        UniformsLib.common,
        UniformsLib.lights,
        {
            thickness: { value: 0.02 },
            strokeColor: { value: new Color(0xffffff) },
            baseColor: { value: new Color(0x000000) },
            cameraCenterWorldPosition: { value: {} },
            worldScale: { value: {} },
            time: { value: 0 }
        }
    ]),
    vertexShader: AVATAR_VERTEX_SHADER,
    fragmentShader: AVATAR_FRAGMENT_SHADER
};
// UniformsUtils.merge() will clone the uniform,
// but we want some of the uniform use the same objects
// therefore we have to override some uniforms.
AVATAR_SHADER.uniforms.cameraCenterWorldPosition = GLOBAL_UNIFORMS.cameraCenterWorldPosition;
AVATAR_SHADER.uniforms.worldScale = GLOBAL_UNIFORMS.platformScale;
AVATAR_SHADER.uniforms.time = GLOBAL_UNIFORMS.time;
